<template>
  <el-form ref="form"
           :model="form"
           label-width="160px">
    <div v-if="notTypeUse">
      <el-row>
        <div class="padding-20"
             style="color: #409eff;">1.1 普通录入</div>
        <br />
        <el-col :span="7">
          <el-form-item label="普通录入:">
            <autocomplete-reset v-model="form.varName"
                                :formData="form"
                                :config="{
                                      url:'/api/blade-vardict/vardict/searchCode',
                                      value:'varNo',
                                      label:'varName',
                                      soleValue :'varNo',
                                    }"
                                style="width:100%">
            </autocomplete-reset>
          </el-form-item>
        </el-col>
        <br />
        <el-col :span="24">
          <el-collapse v-model="activeNames.activeNames1">
            <el-collapse-item title="@code 1.1"
                              name="1.1">
              <div>
                <prism-editor class="my-editor height-300"
                              :key="RichElementCode1_1"
                              v-model="RichElementCode1_1"
                              :highlight="highlighter"
                              readonly
                              line-numbers></prism-editor>
              </div>
            </el-collapse-item>
          </el-collapse>
        </el-col>
      </el-row>
      <el-row>
        <div class="padding-20"
             style="color: #409eff;">1.2 自定义录入 / 高亮关键字 <i style="color: #000;font-size: 13px;">onState:true控制自定义录入 ， highlightShow:true,控制高亮效果</i></div>
        <br />
        <el-col :span="7">
          <el-form-item label="自定义录入:">
            <autocomplete-reset v-model="form.varName2"
                                :formData="form"
                                :config="{
                                      url:'/api/blade-vardict/vardict/searchCode',
                                      value:'varNo',
                                      label:'varName',
                                      soleValue :'varNo2',
                                      onState:true  
                                    }"
                                style="width:100%">
            </autocomplete-reset>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="高亮关键字:">
            <autocomplete-reset v-model="form.varName3"
                                :formData="form"
                                :config="{
                                      url:'/api/blade-vardict/vardict/searchCode',
                                      value:'varNo',
                                      label:'varName',
                                      soleValue :'varNo3',
                                      highlightShow:true,
                                      placeholder:'需配合rich_element@1.1.14使用',
                                      onState:true  
                                    }"
                                style="width:100%">
            </autocomplete-reset>
          </el-form-item>
        </el-col>
        <br />
        <el-col :span="24">
          <el-collapse v-model="activeNames.activeNames2">
            <el-collapse-item title="@code 1.2"
                              name="1.2">
              <div>
                <prism-editor class="my-editor height-300"
                              :key="RichElementCode1_2"
                              v-model="RichElementCode1_2"
                              :highlight="highlighter"
                              readonly
                              line-numbers></prism-editor>
              </div>
            </el-collapse-item>
          </el-collapse>
        </el-col>
      </el-row>
      <el-row>
        <div class="padding-20"
             style="color: #409eff;">1.3 数据带出 / 粘贴处理并带出 <i style="color: #000;font-size: 13px;">@alteration 函数 手动勾选时会触发 ， PasteType:true, 控制处理粘贴数据</i></div>
        <br />
        <el-col :span="7">
          <el-form-item label="数据带出:">
            <autocomplete-reset v-model="form.varName4"
                                :formData="form"
                                :config="{
                                      url:'/api/blade-vardict/vardict/searchCode',
                                      value:'varNo',
                                      label:'varName',
                                      soleValue :'varNo4',
                                      onState:true ,
                                    }"
                                style="width:100%"
                                @alteration="varAlteration">
            </autocomplete-reset>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="粘贴处理并带出:">
            <autocomplete-reset @alteration="varAlteration2"
                                ref="autocomplete"
                                v-model="form.varName5"
                                :formData="form"
                                :config="{
                                      url:'/api/blade-vardict/vardict/searchCode',
                                      value:'varNo',
                                      label:'varName',
                                      soleValue :'varNo5',    
                                      PasteType:true,
                                      onState:true                                 
                                    }"
                                style="width:100%">
            </autocomplete-reset>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-collapse v-model="activeNames.activeNames3">
            <el-collapse-item title="@code 1.3"
                              name="1.2">
              <div>
                <prism-editor class="my-editor height-300"
                              :key="RichElementCode1_3"
                              v-model="RichElementCode1_3"
                              :highlight="highlighter"
                              readonly
                              line-numbers></prism-editor>
              </div>
            </el-collapse-item>
          </el-collapse>
        </el-col>
      </el-row>
      <br />
      <el-divider> 分割 </el-divider>
      <br />
    </div>

    <!-- ========================  简化调用  =============================== -->
    <div v-else>
      <el-row>
        <div class="padding-20"
             style="color: #409eff;">2.1 默认配置 </div>
        <br />
        <!-- 参数与配置相同时 -->
        <el-col :span="7">

          <el-form-item label="默认配置varNo:">
            <autocomplete-reset v-model="form.varName6"
                                typeUse="varNo"
                                :formData="form" />
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="默认配置custNo:">
            <autocomplete-reset v-model="form.varName7"
                                typeUse="custNo"
                                :formData="form" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-collapse v-model="activeNames.activeNames4">
            <el-collapse-item title="@code 2.1"
                              name="2.1">
              <div>
                <prism-editor class="my-editor height-300"
                              :key="RichElementCode2_2"
                              v-model="RichElementCode2_2"
                              :highlight="highlighter"
                              readonly
                              line-numbers></prism-editor>
              </div>
            </el-collapse-item>
          </el-collapse>
        </el-col>
      </el-row>
      <div class="padding-20"
           style="color: #409eff;">2.2 特殊情况（一个或多个参数与默认配置不同） </div>
      <br />
      <el-row>
        <!-- 参数与配置部分不同 -->
        <el-col :span="7">
          <el-form-item label="仅soleValue参数不同:">
            <autocomplete-reset v-model="form.varName8"
                                typeUse="varNo"
                                :formData="form"
                                :config="{soleValue :'varNo',}" />
          </el-form-item>
        </el-col>

        <!-- 多个参数不同时 -->
        <el-col :span="7">
          <el-form-item label="多个参数不同时:">
            <autocomplete-reset v-model="form.varName9"
                                typeUse="varNo"
                                :formData="form"
                                :config="{soleValue :'varNo', PasteType:true,maxlength:'30'}" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-collapse v-model="activeNames.activeNames4">
            <el-collapse-item title="@code 2.2"
                              name="2.2">
              <div>
                <prism-editor class="my-editor height-300"
                              :key="RichElementCode2_2"
                              v-model="RichElementCode2_2"
                              :highlight="highlighter"
                              readonly
                              line-numbers></prism-editor>
              </div>
            </el-collapse-item>
          </el-collapse>
        </el-col>
      </el-row>
    </div>
    <!-- ========================  end  =============================== -->
  </el-form>
</template>

<script>

import { Desc, DescMethod } from '../util/demodesc'   //日志及描述说明文件
DescMethod.initialize()
export default {
  components: {
    PrismEditor: DescMethod.PrismEditor,
  },
  data() {
    return {
      tableData: Desc.tableData,  // rich_element更新功能及说明
      RichElementDesc: Desc.RichElementDesc,  // rich_element更新日志及使用方法
      DateCodeDesc: Desc.DateCodeDesc, //查询时间配置 描述
      RichElementCode1_1: Desc.RichElementCode1_1, //AutocompleteReset拼音码组件代码片段 1.1
      RichElementCode1_2: Desc.RichElementCode1_2, //AutocompleteReset拼音码组件代码片段 1.2
      RichElementCode1_3: Desc.RichElementCode1_3, //AutocompleteReset拼音码组件代码片段 1.3
      RichElementCode2_1: Desc.RichElementCode2_1, //AutocompleteReset拼音码组件代码片段 2.1
      RichElementCode2_2: Desc.RichElementCode2_2, //AutocompleteReset拼音码组件代码片段 2.2
      form: {},
      carryOver: '',
      activeNames: {}
    }
  },
  props: {
    notTypeUse: {
      default: true
    }
  },
  watch: {
    carryOver(val) {
      if (val) {
        this.$refs.autocomplete.$refs.fetchSuggestions.handleFocus()
        this.$refs.autocomplete.autocomplete_key = !this.$refs.autocomplete.autocomplete_key
        const h = this.$createElement;
        this.$msgbox({
          title: '消息',
          message: h('p', null, [
            h('i', { style: 'color: teal' }, '带出结果：'),
            h('div', { style: 'padding: 5px;width:100% ;word-break:break-all; ' }, JSON.stringify(val)),
          ]),
          showCancelButton: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        })
      }

    }
  },
  methods: {
    // 普通带出回调
    varAlteration(event) {
      this.carryOver = event
      console.log('勾选后会带出选中数据对象', '选中数据：', event);
    },
    // 粘贴带出回调
    varAlteration2(event) {
      this.carryOver = event
      console.log('粘贴时若查询结果为一条会模拟选中', '选中数据：', event);
    },
    highlighter(code) {
      return DescMethod.highlight(code, DescMethod.languages.js);
    },
    htmlValue(val) {
      return DescMethod.htmlValue(val)
    },
  }
}
</script>

<style lang="scss" scoped>
$padding-left-20: 20px;

.padding-20 {
  padding-left: $padding-left-20;
}

::v-deep .el-collapse-item__header {
  padding-left: 10px;
  background-color: rgb(247, 247, 247) !important;
}
</style>